export default {
  询比价管理列表: "Price Inquiry Management List",
  新增询价: "Add Inquiry",
  保存成功: "Saved successfully",
  请添加询价物料: "Please add inquiry materials",
  请添加询价物料名称: "Please add material names",
  请添加供应商: "Please add suppliers",
  询价基本信息: "Basic Inquiry Information",
  询价类型: "Inquiry Type",
  请选择询价类型: "Please select inquiry type",
  询价单标题: "Inquiry Title",
  请输入询价单标题: "Please enter inquiry title",
  截止时间: "Deadline",
  请选择截止时间: "Please select deadline",
  询价明细: "Inquiry Details",
  搜索物料: "Search Material",
  添加物料行: "Add Material Row",
  序号: "No.",
  物料编号: "Material Code",
  "物料名称（中文）": "Material Name (CN)",
  "物料名称（英文）": "Material Name (EN)",
  "商品名称（如有）": "Product Name (if any)",
  药典: "Pharmacopoeia",
  标准: "Standard",
  数量: "Quantity",
  数量单位: "Unit",
  备注: "Remarks",
  请输入: "Please enter",
  材料结构: "Material Structure",
  尺寸: "Dimensions",
  其他要求: "Other Requirements",
  类别: "Category",
  物料代号: "Material Code",
  物料名称: "Material Name",
  "CAS No. | Catalogue No.（供应商目录号）": "CAS No. | Catalogue No.",
  "建议包装规格（如：25kg/袋）": "Suggested Pack Size (e.g. 25kg/bag)",
  "备注(品牌/等级要求）": "Remarks (Brand/Grade Requirements)",
  供应商选择: "Supplier Selection",
  共count个供应商: "{count} suppliers",
  清空: "Clear",
  从供应商库选择: "Select from Supplier Database",
  暂无供应商: "No suppliers available",
  全选: "Select All",
  未命名供应商: "Unnamed Supplier",
  绑定需求申请单: "Link Purchase Request (if any)",
  添加: "Add",
  询价单号: "Inquiry No.",
  询价状态: "Status",
  标题: "Title",
  创建人: "Created By",
  创建时间: "Created Time",
  截止日期: "Deadline",
  报价进度: "Quotation Progress",
  操作: "Action",
  比价: "Compare Prices",
  询价单基本信息: "Basic Inquiry Information",
  导出: "Export",
  询价单编号: "Inquiry No.",
  物料类型: "Material Type",
  询价日期: "Inquiry Date",
  关联需求单: "Linked Request",
  询价单要求明细: "Inquiry Requirements",
  目标供应商数量: "Target Suppliers",
  已报价供应商数量: "Quoted Suppliers",
  "最低报价（总价）": "Lowest (Total)",
  "最高报价（总价）": "Highest (Total)",
  物料index: "Material {index}",
  导出当前物料: "Export Current Material",
  比价单: "Price Comparison",
  价格对比: "Price Comparison Chart",
  更多明细: "More Details",
  该供应商未填写报价: "Supplier has not submitted quotation",
  查看更多: "View More",
  供应商名称: "Supplier Name",
  总价: "Total Price",
  单价: "Unit Price",
  货币: "Currency",
  最低起订量: "MOQ",
  国际贸易条款: "Incoterms",
  交货期: "Delivery Time",
  产地: "Origin",
  发货地点: "Shipping From",
  是否含运费: "Freight Included",
  是: "Yes",
  否: "No",
  备注说明: "Remarks",
  单位HKD: "Unit: HKD",
  填报明细: "Fill Details",
  报名截止日期: "Application Deadline: ",
  提交成功: "Submitted successfully",
  总结: "Summary",
  请输入总结: "Enter summary",
  返回: "Back",
  品牌: "Brand",
  产品货号: "Product Code",
  等级: "Grade",
  产品名称: "Product Name",
  规格: "Specification",
  单位: "Unit",
  折扣: "Discount",
  "交货期/天": "Lead Time (days)",
  最小包装规格: "Min Pack Size",
  物料文件: "Material File",
  样品测试情况: "Sample Test Status",
  是否符合澳美的物料信息: "Compliance with Aomei's Material Info",
  关闭: "Close",
  暂存: "Save as Draft",
  发送询价: "Send Inquiry",
};
